<template>
  <div>
    <div
      class="flex border pr-3 pl-3 py-2 mb-2 shadow-md text-red-600 border-red-400 bg-red-100 dark:text-dark-text dark:border-red-900 dark:bg-red-900"
      style="user-select: contain; max-width: 70vw; border-radius: 1rem"
    >
      <div class="">{{ errorMessage }}</div>
      <div class="mt-1 ml-3">
        <button class="focus:outline-none select-none" @click="setIsErrorShow(false)">
          <span class="material-icons text-xl"> close </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import { useFreeSpaceStatePresenter } from '@/presentation/composables/freeSpace/useFreeSpaceStatePresenter'

export default defineComponent({
  components: {},
  props: {
    testJudgeDetail: {
      type: Object,
      required: false
    }
  },
  setup(props, ctx) {
    const testCase = computed(() => (props.testJudgeDetail ? props.testJudgeDetail.submissionRecord : null))
    const testStatus = computed(() => (testCase.value ? testCase.value.status : ''))

    const { setIsErrorShow, errorMessage } = useFreeSpaceStatePresenter()

    const judgeResultStatus = computed<
      | 'INITIAL'
      | 'ERROR'
      | 'ACCEPTED'
      | 'WRONGANSWER'
      | 'COMPILEERROR'
      | 'TIMELIMIT'
      | 'MEMORYLIMIT'
      | 'RUNTIMEERROR'
      | 'PRESENTATIONERROR'
      | 'OUTPUTLIMIT'
    >(() => {
      if (!props.testJudgeDetail) {
        return 'INITIAL'
      }
      switch (props.testJudgeDetail.submissionRecord.status) {
        case 'ACCEPTED':
          return 'ACCEPTED'
        case 'WRONGANSWER':
          return 'WRONGANSWER'
        case 'COMPILEERROR':
          return 'COMPILEERROR'
        case 'TIMELIMIT':
          return 'TIMELIMIT'
        case 'MEMORYLIMIT':
          return 'MEMORYLIMIT'
        case 'RUNTIMEERROR':
          return 'RUNTIMEERROR'
        case 'PRESENTATIONERROR':
          return 'PRESENTATIONERROR'
        case 'OUTPUTLIMIT':
          return 'OUTPUTLIMIT'
        case 'RUNNING':
        case 'WAITING':
          return 'INITIAL'
        default:
          return 'ERROR'
      }
    })

    const errorText = computed(() => {
      if (!props.testJudgeDetail) {
        return ''
      }
      switch (judgeResultStatus.value) {
        case 'INITIAL':
          return ''
        case 'TIMELIMIT':
        case 'MEMORYLIMIT':
        case 'OUTPUTLIMIT':
          return ''
        case 'ERROR':
        case 'RUNTIMEERROR':
        case 'COMPILEERROR':
          return props.testJudgeDetail.compileError || props.testJudgeDetail.runtimeError
        case 'ACCEPTED':
        case 'WRONGANSWER':
        case 'PRESENTATIONERROR':
          return props.testJudgeDetail.userOutput
        default:
          return ''
      }
    })

    return {
      testStatus,
      setIsErrorShow,
      errorMessage
    }
  }
})
</script>

<style lang="postcss"></style>
